import { Controller } from "stimulus";
import humps from 'humps';
import Swal from "sweetalert2";
import { animateModalContainer, closeScheduleModal } from "./calendar/modal-mask-iterations";

export default class extends Controller {
  static targets = [
    'agenda',
    'form',
    'inputDate',
    'scheduleModalMask',
    'attendanceDateTime',
    'hiddenFieldsWrapper',
    'requesterComment',
    'selectService',
    'selectProfessor',
    'selectLocation'
  ];

  static values = {
    individual: Boolean
  }

  connect() {
    this.element.dataset.hideBoarding !== 'true' && Swal.fire({
      title: 'Próximo Passo',
      html: 'Selecione a aula desejada para a reposição.',
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      showCancelButton: false,
      confirmButtonText: 'Continuar'
    });

    if (this.individualValue) {
      this.element.querySelectorAll('.table-row .table-cell').forEach(($tableCell) => {
        $tableCell.querySelectorAll('.card').length == 0 && $tableCell.classList.add('pointer');
        $tableCell.addEventListener('click', (ev) => {
          if (!ev.target.classList.contains('table-cell-container')) return;
          if (!ev.target.classList.contains('disabled')) return this.prepareToSelectSchedule($tableCell);

          Swal.fire({
            html: 'Horário fora do intervalo permitido para seleção.',
            showClass: { backdrop: 'swal2-noanimation', popup: '', },
            hideClass: { popup: '' },
            customClass: { cancelButton: 'btn btn-gray-primary' },
            buttonsStyling: false,
            showCancelButton: true,
            showConfirmButton: false,
            focusCancel: true,
            cancelButtonText: 'Fechar'
          })
        });
      });
    } else {
      this.element.querySelectorAll('.table-cell-container:not(.disabled) .card:not(.readonly)').forEach(($card) => $card.addEventListener('click', (ev) => {
        this.openRequestRescheduleDialog($card, humps.camelizeKeys(JSON.parse($card.dataset.schedule)));
      }));
    }

    [this.scheduleModalMaskTarget.querySelector('.modal-actions span.close-action'), this.scheduleModalMaskTarget].forEach(($el) => $el.addEventListener('click', (ev) => this.onCloseScheduleModal(ev)));
  }

  prepareToSelectSchedule($cell) {
    this.selectedSchedule = {
      startTime: $cell.dataset.startTime,
      endTime: $cell.dataset.endTime,
      dayName: $cell.dataset.dayName,
      dayShort: $cell.dataset.dayShort,
      weekDay: $cell.dataset.dayIndex,
      date: $cell.dataset.date,
      serviceId: this.selectServiceTarget.value,
      professorId: this.selectProfessorTarget.value,
      locationId: (this.hasSelectLocationTarget ? this.selectLocationTarget.value : undefined),
      appendUID: !!this.element.dataset.appendUid ? this.element.dataset.appendUid === 'true' : true
    };
    this.selectedCard = this.insertDraftSchedule($cell);
    setTimeout(() => this.openRequestRescheduleDialog(this.selectedCard, this.selectedSchedule), 100) // wait animations end
  }

  insertDraftSchedule($cell) {
    return this.insertCard($cell, 'open draft');
  }

  insertCard($cell, cssStyle, title = 'Novo Horário') {
    let uid = `id-${new Date().getTime() + Math.ceil(Math.random() * 10)}`;

    $cell.querySelector('.table-cell-container').insertAdjacentHTML('beforeEnd', `
      <div class="card selected-schedule ${cssStyle}" id="${uid}">
        <div class="content">
          <div class="content-container">
            <div class="line-clamp-1 title">${title}</div>
            <div class="time">${$cell.dataset.startTime} às ${$cell.dataset.endTime}</div>
          </div>
        </div>
      </div>
    `);

    return $cell.querySelector(`#${uid}`);
  }

  openRequestRescheduleDialog($card, schedule) {
    let [year, month, day] = schedule.date.split('-'),
      [hour, minute] = schedule.startTime.split(':');

    this.attendanceDateTimeTarget.innerHTML = `${day}/${month}/${year} ${hour}:${minute}`;
    this.hiddenFieldsWrapperTarget.innerHTML = `
      <input type="hidden" name="date" value="${schedule.date}" />
      <input type="hidden" name="start_time" value="${schedule.startTime}" />
      <input type="hidden" name="end_time" value="${schedule.endTime}" />
      ${!!schedule.professorId ? `<input type="hidden" name="professor_id" value="${schedule.professorId}" />` : ''}
      ${!!schedule.locationId ? `<input type="hidden" name="location_id" value="${schedule.locationId}" />` : '' }
      ${!!schedule.batchId ? `<input type="hidden" name="batch_id" value="${schedule.batchId}" />` : '' }
      ${!!schedule.batchScheduleId ? `<input type="hidden" name="batch_schedule_id" value="${schedule.batchScheduleId}" />` : ''}
    `;

    animateModalContainer($card, this.scheduleModalMaskTarget);
    document.querySelector('.schedule-mask').style.removeProperty('z-index');
  }

  removeDraftSchedules() {
    this.element.querySelectorAll('.card.draft').forEach(($card) => {
      $card.style.width = '0px';
      $card.style.opacity = '0';
      setTimeout(() => $card.remove(), 100);
    });
  }

  async onCloseScheduleModal(ev) {
    try {
      await closeScheduleModal.bind(this)(ev);
      this.removeDraftSchedules();
      this.resetRequestRescheduleModal();
    } catch (ex) {}
  }

  resetRequestRescheduleModal() {
    this.requesterCommentTarget.value = '';
    this.attendanceDateTimeTarget.innerHTML = '';
    this.hiddenFieldsWrapperTarget.innerHTML = '';
  }
}